// src/components/Home.js
import React, { useState, useEffect } from 'react'; 
import { API } from 'aws-amplify'; 
import { listVehicles } from '../graphql/queries'; 
import { Link } from 'react-router-dom';
import Footer from './Footer'; 
import Carousel from './Carousel'; 
// 🚀 IMPORTACIÓN DE LA NUEVA SECCIÓN DE CARACAS
import CaracasHero from './CaracasHero'; 
import { FaYoutube, FaInstagram, FaFacebook, FaTiktok, FaEnvelope, FaWhatsapp } from 'react-icons/fa'; 
import { FaShieldAlt, FaHandshake, FaCarSide } from 'react-icons/fa'; 

// --- Rutas de Recursos ---
const YOUTUBE_VIDEO_ID = "QsUT28Kxe3Y"; 
const YOUTUBE_VIDEO_URL = `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?controls=0`;
const WHATSAPP_NUMBER = "13054076280"; 
const WHATSAPP_CTA = `https://wa.me/${WHATSAPP_NUMBER}`; 


// --- FUNCIONES AUXILIARES DE IMAGEN (CORRECCIÓN DE BUCKET) ---
const getS3ImageUrl = (imageKey) => {
    if (!imageKey) return 'placeholder.jpg';
    
    // 🟢 BUCKET NAME CORREGIDO: Usando el bucket de ProdStable para consistencia
    const BUCKET_NAME = "amplify-vimcarbrokerwebnew-prodstable-cdd61-deployment"; 
    const REGION = "us-east-1"; 
    
    // Ruta corregida: /public/KEY
    return `https://${BUCKET_NAME}.s3.${REGION}.amazonaws.com/public/${imageKey}`;
};


// --- Componente de Tarjeta de Vehículo (REUTILIZABLE) ---
const VehicleCard = ({ vehicle }) => (
    <div style={{ 
        border: '1px solid #ccc', 
        padding: '15px', 
        margin: '10px', 
        width: '300px', 
        textAlign: 'center', 
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)', 
        backgroundColor: 'white',
        transition: 'transform 0.3s'
    }}
    onMouseOver={e => e.currentTarget.style.transform = 'translateY(-5px)'}
    onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}
    >
        <img 
            src={getS3ImageUrl(vehicle.imageKey)} 
            alt={`${vehicle.year} ${vehicle.make}`} 
            style={{ width: '100%', height: '200px', objectFit: 'cover', marginBottom: '10px', borderRadius: '4px' }}
            onError={(e) => { e.target.onerror = null; e.target.src = 'placeholder.jpg'; }}
        />
        <h3 style={{fontSize: '1.2em', margin: '10px 0'}}>{vehicle.year} {vehicle.make} {vehicle.model}</h3>
        <p style={{fontWeight: 'bold', color: '#dc3545', fontSize: '1.4em'}}>
            ${vehicle.price?.toLocaleString()}
        </p>
        <p style={{fontSize: '0.9em', color: '#6c757d'}}>
            Millas: {vehicle.mileage?.toLocaleString()} | Estado: {vehicle.titleStatus}
        </p>
        <Link to={`/vehiculo/${vehicle.id}`} style={{ textDecoration: 'none' }}>
            <button 
                style={{ 
                    padding: '8px 15px', 
                    marginTop: '10px', 
                    backgroundColor: '#007bff', 
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '4px', 
                    cursor: 'pointer', 
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s'
                }}
                onMouseOver={e => e.currentTarget.style.backgroundColor = '#0056b3'}
                onMouseOut={e => e.currentTarget.style.backgroundColor = '#007bff'}
            >
                Ver Detalles
            </button>
        </Link>
    </div>
);


// --- Componente de Módulo de Vehículos (SIN CAMBIOS EN LÓGICA DE CARGA) ---
const VehicleModule = ({ title, cta, vehicles, id, loading, error }) => (
    <div id={id} style={{ padding: '40px 20px', border: '1px solid #ddd', borderRadius: '8px', margin: '40px 0', textAlign: 'center' }}>
        <h2 style={{ color: '#007bff', marginBottom: '20px' }}>{title}</h2>
        
        {loading && <p>Cargando vehículos...</p>}
        
        {error && <p style={{color: 'red', fontWeight: 'bold'}}>🚨 Error: {error}. La conexión falló. 🚨</p>}
        
        {!loading && vehicles.length === 0 && (
            <p style={{ marginBottom: '30px', color: '#6c757d' }}>
                No hay vehículos disponibles en esta sección por el momento.
            </p>
        )}
        
        {vehicles.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px', marginBottom: '30px' }}>
                {vehicles.map(v => <VehicleCard key={v.id} vehicle={v} />)}
            </div>
        )}

        <Link to="/catalogo" style={{ textDecoration: 'none' }}>
             <button style={{ 
                 padding: '12px 25px', 
                 background: '#28a745', 
                 color: 'white', 
                 border: 'none', 
                 borderRadius: '8px', 
                 cursor: 'pointer', 
                 fontWeight: 'bold',
                 fontSize: '1.1em',
                 boxShadow: '0 4px 6px rgba(40,167,69,0.3)',
                 transition: 'background-color 0.3s'
                 }}
                 onMouseOver={e => e.currentTarget.style.backgroundColor = '#1e7e34'}
                 onMouseOut={e => e.currentTarget.style.backgroundColor = '#28a745'}
            >
                {cta}
            </button>
        </Link>
    </div>
);

// --- Resto de Componentes de Diseño (sin cambios) ---
const ReasonCard = ({ iconComponent, title, description }) => (
    <div style={{ flexBasis: 'calc(33% - 40px)', minWidth: '250px', padding: '20px', border: '1px solid #eee', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.05)', textAlign: 'center' }}>
        <div style={{ color: '#007bff', fontSize: '40px', marginBottom: '15px' }}>
            {iconComponent}
        </div>
        <h3 style={{color: '#007bff'}}>{title}</h3>
        <p>{description}</p>
    </div>
);

const MediaSection = () => (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center', padding: '20px' }}>
        {/* Módulo de YouTube */}
        <div id="youtube" style={{ flexBasis: 'calc(50% - 30px)', minWidth: '300px', textAlign: 'center' }}>
            <h2 style={{ color: '#007bff', marginBottom: '20px' }}>Nuestro Canal de YouTube</h2>
            <div style={{ border: '1px solid #eee', marginBottom: '20px', padding: '5px', borderRadius: '8px' }}>
                <iframe 
                    width="100%" 
                    height="315" 
                    src={YOUTUBE_VIDEO_URL} 
                    title="YouTube video player" 
                    frameBorder="0" 
                    allowFullScreen
                    style={{maxWidth: '560px', borderRadius: '4px'}}
                ></iframe>
            </div>
            <a href="https://www.youtube.com/@VimcarBroker" target="_blank" rel="noopener noreferrer">
                <button style={{ padding: '10px 20px', background: '#ff0000', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                    ▶️ Suscríbete a nuestro canal
                </button>
            </a>
        </div>

        {/* Módulo de NEWSLETTER */}
        <div id="newsletter" style={{ flexBasis: 'calc(40% - 30px)', minWidth: '300px', backgroundColor: '#f0f8ff', padding: '30px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 4px 8px rgba(0,0,0,0.05)' }}>
            <h2 style={{ color: '#007bff', marginBottom: '20px' }}>NEWSLETTER VIP</h2>
            <p style={{ marginBottom: '20px' }}>Suscríbete para recibir ofertas y tips.</p>
            <input type="email" placeholder="Introduce tu correo electrónico" style={{ width: '100%', padding: '10px', marginBottom: '15px', border: '1px solid #ccc', borderRadius: '4px' }} />
            <button style={{ padding: '10px 20px', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', width: '100%' }}>
                Suscribirme
            </button>
        </div>
    </div>
);


export default function Home() { 
    const [vehicles, setVehicles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchVehicles();
    }, []);

    const fetchVehicles = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await API.graphql({ 
                query: listVehicles,
                variables: { 
                    filter: { status: { eq: "FOR_SALE" } }, 
                    // El límite de la consulta sigue siendo 50, filtramos en el cliente
                    limit: 50 
                },
                // 🟢 CORRECCIÓN: Forzar API_KEY para el acceso público en Home
                authMode: 'API_KEY' 
            });
            
            const fetchedVehicles = response.data.listVehicles.items || [];
            
            setVehicles(fetchedVehicles.filter(v => v.status === 'FOR_SALE'));

        } catch (err) {
            console.error("Error al cargar vehículos en Home:", err);
            setError("Error de conexión con el catálogo. (Revise su API Key).");
        } finally {
            setLoading(false);
        }
    };
    
    // Filtros de vehículos
    const featuredVehicles = vehicles.filter(v => v.isFeatured);
    const cashDeals = vehicles.filter(v => v.isCashDeal);
    
    return (
        <main>
            
            {/* CTA Flotante de WhatsApp */}
            <a href={WHATSAPP_CTA} target="_blank" rel="noopener noreferrer" style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                backgroundColor: '#25D366', 
                color: 'white',
                padding: '12px 18px',
                borderRadius: '50%',
                fontSize: '24px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.4)',
                zIndex: 1000,
                textDecoration: 'none',
                display: 'flex', 
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <FaWhatsapp /> 
            </a>

            {/* CARRUSEL */}
            <Carousel /> 
            
            <section style={{ maxWidth: '1200px', margin: '0 auto' }}>

                {/* 🚀 NUEVA SECCIÓN: TOYOTA FRONTLANDER CARACAS */}
                <CaracasHero />
                
                {/* 1. Vehículos Destacados (AHORA MUESTRA HASTA 9 AUTOS) */}
                <VehicleModule 
                    id="destacados" 
                    title="Vehículos Por Financiamiento" 
                    cta="Explorar Inventario"
                    // 🔑 CAMBIO CRÍTICO: .slice(0, 9) para mostrar hasta 9 vehículos
                    vehicles={featuredVehicles.slice(0, 9)} 
                    loading={loading}
                    error={error}
                />
                
                {/* 2. Vehículos "CASH" (AHORA MUESTRA HASTA 9 AUTOS) */}
                <VehicleModule 
                    id="cash" 
                    title="Oportunidades CASH / Trade-ins" 
                    cta="Ver Vehículos Económicos" 
                    // 🔑 CAMBIO CRÍTICO: .slice(0, 9) para mostrar hasta 9 vehículos
                    vehicles={cashDeals.slice(0, 9)} 
                    loading={loading}
                    error={error}
                />
                
                {/* 3. Quiénes Somos y Por Qué Elegirnos (AHORA DEBAJO DE LAS SECCIONES DE AUTOS) */}
                <div id="quienes-somos" style={{ padding: '40px 20px', backgroundColor: '#f9f9f9', borderRadius: '8px', margin: '40px 0', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                    <h2 style={{ textAlign: 'center', color: '#007bff', marginBottom: '20px' }}>Quiénes Somos</h2>
                    <p style={{ fontSize: '1.1em', lineHeight: '1.6', textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
                        En **Vimcarbroker**, nuestra misión es conectar a las personas con los vehículos que desean, de manera sencilla y transparente. Entendemos que la compra de un auto es una de las decisiones más importantes, por lo que ofrecemos un servicio de broker de confianza para que encuentres el auto perfecto al mejor precio.
                        <br/><br/>
                        Trabajamos para ti, buscando en una extensa red de concesionarios para garantizar que obtengas la mejor oferta, ya sea para un vehículo nuevo o usado. Nuestra experiencia y dedicación están a tu disposición para hacer de tu próxima compra una experiencia agradable y sin complicaciones.
                    </p>
                </div>


                <h2 style={{ textAlign: 'center', margin: '40px 0', color: '#333' }}>Por Qué Elegirnos</h2>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', gap: '30px', textAlign: 'center', padding: '20px' }}>
                    <ReasonCard 
                        iconComponent={<FaShieldAlt />} 
                        title="Transparencia y Confianza" 
                        description="Accede a precios finales sin sorpresas. Nuestro proceso de broker garantiza la mejor oferta y te protege contra precios inflados." 
                    />
                    <ReasonCard 
                        iconComponent={<FaHandshake />} 
                        title="Network Exclusiva de Dealers" 
                        description="Trabajamos con una red selecta de concesionarios en el Sur de la Florida, dándote acceso prioritario a inventario premium." 
                    />
                    <ReasonCard 
                        iconComponent={<FaCarSide />} 
                        title="Asesoría de Compra Personalizada" 
                        description="Te acompañamos de inicio a fin. Nos enfocamos en encontrar el vehículo que se ajuste a tus deseos y presupuesto, no al de ellos." 
                    />
                </div>
            
                {/* YouTube / Newsletter */}
                <MediaSection />

            </section>
            
            <Footer /> 
        </main>
    );
}